// extracted by mini-css-extract-plugin
module.exports = {"root":"search_root__aVbZ2","searchInput":"search_searchInput__2iXH3","searchIcon":"search_searchIcon__3cAc1","searchContainer":"search_searchContainer__2iriw"};